import React, { Fragment } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';

const ProductPageSEO = React.memo(
    ({ product }) => {
        const { schemas } = product;

        return (
            <Fragment>
                {!!schemas?.length &&
                    schemas.map(schema => (
                        <script
                            key={schema['@type']}
                            type='application/ld+json'
                            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
                        ></script>
                    ))}
            </Fragment>
        );
    },
    (prevProps, nextProps) => prevProps.product.schemas === nextProps.product.schemas
);

export default wrapFunctionalComponent(ProductPageSEO, 'ProductPageSEO');
